import { API } from "@js/api";
import type { WithdrawalMethodType } from "@js/types/withdrawals";
import { getUseQueryHookWithDefaultOptions } from "@js/utils/store";

import type {
  CreateDashboardLinkResultType,
  CreateOnboardingLinkResultType,
} from "./types";

export const withdrawalApi = API.injectEndpoints({
  endpoints: (build) => ({
    getWithdrawalMethods: build.query<WithdrawalMethodType[], void>({
      query: () => ({
        url: `/withdrawal_methods/`,
        method: "GET",
      }),
      providesTags: ["WithdrawalMethods"],
    }),
    createDashboardLink: build.mutation<CreateDashboardLinkResultType, number>({
      query: (id) => ({
        url: `/stripe_recipients/${id}/dashboard_link/`,
        method: "POST",
      }),
    }),
    createOnboardingLink: build.mutation<
      CreateOnboardingLinkResultType,
      number
    >({
      query: (id) => ({
        url: `/stripe_recipients/${id}/onboarding_link/`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useCreateDashboardLinkMutation,
  useCreateOnboardingLinkMutation,
} = withdrawalApi;

export const useGetWithdrawalMethodsQuery = getUseQueryHookWithDefaultOptions(
  withdrawalApi.useGetWithdrawalMethodsQuery,
  { refetchOnMountOrArgChange: false },
);
